import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ListDataService } from '../services/list-data.service';
import { ListItem } from '../models/ListItem';
import { TicketMaintenanceService } from '../services/ticket-maintenance.service';
import { TicketMaintenanceParameters } from '../models/TicketMaintenanceParameters';
import { TMLoadsComponent } from './tm-loads.component';
import { forkJoin } from 'rxjs';
import { TicketMaintenanceLoadItem } from '../models/TicketMaintenanceLoadItem';
import { UserDataService } from '../services/user-data.service';
import { UserSettingsService } from '../services/user-settings.service';

@Component({
    selector: 'ticket-maintenance',
    templateUrl: 'ticket-maintenance.component.html',
    styles: [
        `
    .pa-btn {
        background-color: #009aee;
        font-weight: bold;
    }

    .dlvd-btn {
        background-color: #FFA07A;
        font-weight: bold;
    }

    .fs-btn {
        background-color: #FFD700;
        font-weight: bold;
    }

    .email-container {
        display: flex;
        align-items: center;
    }

    .email-textarea {
        margin-left: 10px;
        border-radius: 4px;
        border: 1px solid #ccc;
        resize: none;
        transition: all 300ms ease-in-out;
    }

    `
    ],
    standalone: false
})
export class TicketMaintenanceComponent {
  defaultPlanPeriod: string = 'MonthCurrent';
  errorMessage: string = '';
  locList: ListItem[] = [];
  locCodeTm: string = '';
  startDate: string;
  endDate: string;
  deliveredDate: string;
  hasLoaded: boolean = null;
  paCount: number = 0;
  dlvdCount: number = 0;
  fsCount: number = 0;
  ticketMaintenanceParameters: TicketMaintenanceParameters;
  @ViewChild(TMLoadsComponent) childGrid!: TMLoadsComponent;
  totalCounter: number;
  filteredDataCount: number;

  loads: TicketMaintenanceLoadItem[] = [];

    constructor(private _listDataService: ListDataService, private cdr: ChangeDetectorRef, private _ticketMaintenanceService: TicketMaintenanceService, private _userDataService: UserDataService, private _userSettingsService: UserSettingsService) { }

  ngOnInit(): void {

    this.initLoadData('initial');
  }

  initLoadData(type: string) {
    forkJoin({
        locList: this._listDataService.getListItems("loc"),
        userSettings: this._userDataService.getUserSettings()
    }).subscribe({
      next: ({ locList, userSettings }) => {
        const todaysDate = new Date();

        if (type == "initial") {
          this.locList = locList;
          const storedLocCodeTm = sessionStorage.getItem('locCode');
          this.locCodeTm = storedLocCodeTm || userSettings.defaultLocCode;

          //set start date and end date       
          {
            const dayOfWeek = todaysDate.getDay();
            const daysDiffUntilNextSunday = (7 - dayOfWeek) % 7;

            const nextSunday = new Date(todaysDate);
            nextSunday.setDate(todaysDate.getDate() + daysDiffUntilNextSunday);

            this.endDate = this.formatDate(nextSunday.toLocaleDateString());

            const startDate = new Date(nextSunday);
            startDate.setDate(nextSunday.getDate() - 28);

            const startDayOfWeek = startDate.getDay();
            const daysUntilMonday = (8 - startDayOfWeek) % 7;
            startDate.setDate(startDate.getDate() + daysUntilMonday);
            this.startDate = this.formatDate(startDate.toLocaleDateString());
          }
        }

        this.deliveredDate = this.formatDate(todaysDate.toLocaleDateString());

        if (this.locCodeTm.length > 0 && type != '') {
          this.refreshLoadsData(this.locCodeTm);
        }
      },
      error: err => {
        this.errorMessage = err;
      }
    });
  }

  formatDate(dateTimeString: string): string {
    const datePart = dateTimeString.split(' ')[0];

    const [month, day, year] = datePart.split('/');

    const formattedMonth = month.padStart(2, '0');
    const formattedDay = day.padStart(2, '0');

    return `${year}-${formattedMonth}-${formattedDay}`;
  }

  updateTotalCounter(totalCounter: number) {
    this.totalCounter = totalCounter;
  }

  updateFSPADlvdCount(data: TicketMaintenanceLoadItem[], isFiltered: boolean) {
    this.paCount = data?.filter(x => x.preAdvise == true)?.length;
    this.dlvdCount = data?.filter(x => x.delivered == true)?.length;
    this.fsCount = data?.filter(x => x.finalSettled == true)?.length;
    this.filteredDataCount = data?.length;
    if (!isFiltered) {
      this.initLoadData('update');
    }
  }

  refreshLoadsData(locCodeC: string) {
    this.hasLoaded = false;
    this.filteredDataCount = 0;
    this.ticketMaintenanceParameters = {
      endDate: this.endDate,
      startDate: this.startDate,
      deliveredDate: this.deliveredDate,
      locCode: this.locCodeTm
    }

    this._ticketMaintenanceService.getLoadsForTicketMaintenance(this.ticketMaintenanceParameters).subscribe({
      next: data => {
        this.hasLoaded = true;
        this.loads = data;
        this.paCount = data?.filter(x => x.preAdvise == true)?.length;
        this.dlvdCount = data?.filter(x => x.delivered == true)?.length;
        this.fsCount = data?.filter(x => x.finalSettled == true)?.length;
        this.locCodeTm = locCodeC;
        this.cdr.detectChanges();
      },
      error: err => this.errorMessage = err
    });
  }

  updatePA() {
    const selectedItems = this.childGrid.getSelectedItems();
    if (selectedItems.length > 0) {
      this._ticketMaintenanceService.updatePA(selectedItems).subscribe((response) => {
        if (response) {
          this.loads.filter(load => selectedItems.includes(load.loadId)).forEach(element => {
            element.preAdvise = !element.preAdvise;
            element.isSelected = false;
            element.include = false;
            this.cdr.detectChanges();
          });
          this.updateFSPADlvdCount(this.loads, false);
        }
      });
    }
  }

  updateFS() {
    const selectedItems = this.childGrid.getSelectedItems();
    if (selectedItems.length > 0) {
      this._ticketMaintenanceService.updateFS(selectedItems).subscribe((response) => {
        if (response) {
          this.childGrid.clearSelectedItems();
          this.loads.filter(load => selectedItems.includes(load.loadId)).forEach(element => {
            element.finalSettled = !element.finalSettled;
            element.isSelected = false;
            element.include = false;
            this.cdr.detectChanges();
          });
          this.updateFSPADlvdCount(this.loads, false);
        }
      });
    }
  }

  updateDlvd() {
    const selectedItems = this.childGrid.getSelectedItems();
    if (selectedItems.length > 0) {
      this._ticketMaintenanceService.updateDlvd(selectedItems).subscribe((response) => {
        if (response) {
          this.childGrid.clearSelectedItems();
          this.loads.filter(load => selectedItems.includes(load.loadId)).forEach(element => {
            element.delivered = !element.delivered;
            element.isSelected = false;
            element.include = false;
            this.cdr.detectChanges();
          });
          this.updateFSPADlvdCount(this.loads, false);
        }
      });
    }
  }

  updateDeliveredDate() {
    const selectedItems = this.childGrid.getSelectedItems();
    if (selectedItems.length > 0) {
      this._ticketMaintenanceService.updateDeliveredDate(selectedItems, this.deliveredDate).subscribe((response) => {
        if (response) {
          this.childGrid.clearSelectedItems();
          this.loads.filter(load => selectedItems.includes(load.loadId)).forEach(element => {
            let parts = this.deliveredDate.split("-");
            let formattedDate = `${parts[1]}/${parts[2]}/${parts[0]}`;
            element.deliveredDate = formattedDate;
            element.delivered = !element.delivered;
            element.isSelected = false;
            element.include = false;
            this.cdr.detectChanges();
          });
          this.updateFSPADlvdCount(this.loads, false);
        }
      });
    }
  }

  exportExcel() {
    this.childGrid.exportExcel();
  }


  resetSort() {
    this.childGrid.clearSorting();
  }

  clearFilters() {
    this.childGrid.clearFilters();
  }

  onLocCodeTmChange(event: any) {
    this._userSettingsService.setCurrentLocCode(event.target.value);
  }
}
